export interface ConsumerFactors {
  income: string;
  incomeType: string;
  housingType: string;
  housingCost: string;
}

export const emptyConsumerFactors: ConsumerFactors = {
  income: '',
  incomeType: '',
  housingType: '',
  housingCost: '',
};
